import React from 'react';

const BillingDetails = ({ billingAddress, handleInputChange, zipCodeError }) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow-md w-[750px] max-sm:w-full border-2 border-[#007D44]">
            <h2 className="text-xl font-bold mb-4">Billing Details</h2>
            <form className="border-b-2 max-sm:w-full">
                <div className="flex justify-between max-sm:flex-col">
                    <div className="mb-4 w-1/2 max-sm:w-full">
                        <label className="block text-gray-700">First name *</label>
                        <input
                            type="text"
                            name="firstName"
                            value={billingAddress.firstName}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border rounded-lg outline-none"
                            placeholder="First Name"
                            required
                        />
                    </div>
                    <div className="mb-4 w-1/2 max-sm:w-full">
                        <label className="block text-gray-700">Last name *</label>
                        <input
                            type="text"
                            name="lastName"
                            value={billingAddress.lastName}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border rounded-lg outline-none"
                            placeholder="Last Name"
                            required
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700">Country / Region *</label>
                    <select
                        name="country"
                        value={billingAddress.country}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border rounded-lg outline-none"
                        required
                    >
                        <option value="United States">United States</option>
                        {/* Add more country options here */}
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700">Street address *</label>
                    <input
                        type="text"
                        name="streetHouseApartment"
                        value={billingAddress.streetHouseApartment}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border rounded-lg outline-none"
                        placeholder="House number and street name"
                        required
                    />
                    <input
                        type="text"
                        name="apartment"
                        value={billingAddress.apartment}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 mt-3 border rounded-lg outline-none"
                        placeholder="Apartment suite, unit, etc. (optional)"
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700">Town / City *</label>
                    <input
                        type="text"
                        name="city"
                        value={billingAddress.city}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border rounded-lg outline-none"
                        placeholder="Town/City"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700">State *</label>
                    <input
                        type="text"
                        name="state"
                        value={billingAddress.state}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border rounded-lg outline-none"
                        placeholder="State"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700">Zip Code *</label>
                    <input
                        type="text"
                        name="zipCode"
                        value={billingAddress.zipCode}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-3 border rounded-lg outline-none ${
                            zipCodeError ? 'border-red-500' : ''
                        }`}
                        placeholder="Zipcode"
                        required
                    />
                    {zipCodeError && (
                        <p className="text-red-500 text-sm mt-1">{zipCodeError}</p>
                    )}
                </div>

                <div className="flex justify-between max-sm:flex-col">
                    <div className="mb-4 w-1/2 max-sm:w-full">
                        <label className="block text-gray-700">Phone *</label>
                        <input
                            type="text"
                            name="phone"
                            value={billingAddress.phone}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border rounded-lg outline-none"
                            placeholder="Phone"
                            required
                        />
                    </div>
                    <div className="mb-4 w-1/2 max-sm:w-full">
                        <label className="block text-gray-700">Email *</label>
                        <input
                            type="email"
                            name="email"
                            value={billingAddress.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border rounded-lg outline-none"
                            placeholder="Email"
                            required
                        />
                    </div>
                </div>
            </form>

            <div className="mb-4 mt-5">
                <label className="block text-gray-700">Order notes (optional)</label>
                <textarea
                    className="w-full px-4 py-3 border rounded-lg outline-none"
                    placeholder="Notes about your order, e.g. special note for delivery"
                ></textarea>
            </div>
        </div>
    );
};

export default BillingDetails;